import React from 'react';
import Loader from '../../../../loader/Loader';
import mergeClassnames from '../../../../mergeClassnames/mergeClassnames';
import GenericCheckAlternative from '../../../../private/icons/GenericCheckAlternative';
import IconLeft from '../../../styles/IconLeft';
import IconRight from '../../../styles/IconRight';
import getIconSize from '../buttonSizes/getIconSize';
import getLoaderSize from '../buttonSizes/getLoaderSize';
import getLoaderColor from '../buttonStyles/getLoaderColor';
const AnimationContent = ({ children, iconLeft, iconRight, iconOnly, animation, size, fullWidth, variant, }) => (React.createElement("span", { className: "block h-full pointer-events-none" },
    React.createElement("span", { className: mergeClassnames('flex absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 content-center', 'justify-center') },
        animation === 'progress' && (React.createElement(Loader, { size: getLoaderSize(size), color: getLoaderColor(variant) })),
        animation === 'success' && (React.createElement(GenericCheckAlternative, { "aria-label": "Success", className: getIconSize(size) }))),
    React.createElement("span", { className: "flex gap-2 items-center opacity-0" },
        iconLeft && (React.createElement(IconLeft, { fullWidth: fullWidth, iconLeft: iconLeft, size: size })),
        children,
        iconRight && (React.createElement(IconRight, { fullWidth: fullWidth, iconRight: iconRight, size: size })),
        iconOnly)));
export default AnimationContent;
